<template>
  <IconLucideCalendarCheck2 />
</template>
